<template>
  <v-container>
    <v-layout column wrap align-content-center justify-center>
      <v-card>
        <v-toolbar color="primary" dark flat>
          <v-toolbar-title>Unsubscribe</v-toolbar-title>
        </v-toolbar>
        <v-card-text class="pt-4">
          <v-layout wrap style="width: 600px">
            <v-flex xs12>
              <v-alert v-if="error" border="bottom" colored-border type="error">
                {{ error }}
              </v-alert>
            </v-flex>
            <p class="display-1">
              What type of communications would you like to unsubscribe from?
            </p>
            <v-flex xs12>
              <v-form
                v-model="valid"
                ref="form"
                lazy-validation
                class="flex-grow-1"
                autocomplete="on"
              >
                <v-treeview
                  :items="treeItems"
                  selectable
                  hoverable
                  v-model="contactTypes"
                  item-key="contactMethodId"
                  return-object
                  open-all
                  selection-type="leaf"
                ></v-treeview>
                <v-alert v-if="success" border="left" type="success">
                  {{ success }}
                </v-alert>
                <v-layout justify-space-between>
                  <router-link to="/" color="accent"
                    >Manage Your Subscriptions</router-link
                  >
                  <v-spacer></v-spacer>
                  <v-btn
                    type="submit"
                    @click.prevent="submit"
                    :disabled="!valid"
                    color="secondary"
                    >Unsubscribe Now</v-btn
                  >
                </v-layout>
              </v-form>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-progress-linear
          indeterminate
          :active="showLoading"
        ></v-progress-linear>
      </v-card>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      valid: true,
      showLoading: false,
      contactTypes: [],
      success: "",
      error: "",
    };
  },
  computed: {
    treeItems() {
      return [
        {
          contactMethodId: -1,
          name: "All",
          children: this.$store.state.contactMethods || [
            { contactMethodId: -2 },
          ],
        },
      ];
    },
  },
  methods: {
    submit() {
      this.showLoading = true;
      this.$store.state.axios
        .put(
          "api/subscription/" +
            this.$store.state.user.cnxUserId +
            "/unsubscribe",
          this.contactTypes.map((x) => x.contactMethodId)
        )
        .then(() => {
          this.success = "Succesfully unsubscribed";
        })
        .catch((e) => {
          if (e && e.response && e.response.data && e.response.data.message)
            this.error = e.response.data.message;
          else this.error = "Something went wrong. Please try again later";
        })
        .finally(() => {
          this.showLoading = false;
        });
    },
    clear() {
      this.$refs.form.reset();
    },
  },
  async created() {
    await this.$store.dispatch("getContactMethods");
  },
};
</script>
